import type { FrontModule } from "@core/modules";
import "./finances.css";
import { TreasuryPage } from "./analytics";
import { BudgetPage } from "./budget";
import { CommunicationsPage } from "./communications";
import { ContractsPage } from "./contracts";
import { FinanceDashboard } from "./dashboard";
import { ExportPage } from "./export";
import { InboxPage } from "./inbox";
import { DocumentsPage, LeaseSharesTab, PublicSharePage, TenantSharedSection } from "./library";
import { MeetingsPage } from "./meetings";
import { MetersPage, PropertyMetersTab } from "./meters";
import { OperationsPage, PropertyFinanceTab } from "./operations";
import { CondoPage } from "./syndic";

// Module « finances » : recettes et dépenses, trésorerie et rendement, budget, export comptable,
// boîte de réception, documents partagés, contrats fournisseurs, copropriété, compteurs, assemblées
// générales et communications collectives (F-078 à F-088).
export const module: FrontModule = {
  name: "finances",
  orgRoutes: [
    { path: "finances/recettes-et-depenses", element: <OperationsPage /> },
    { path: "finances/tresorerie", element: <TreasuryPage /> },
    { path: "finances/budget", element: <BudgetPage /> },
    { path: "finances/export-comptable", element: <ExportPage /> },
    { path: "finances/boite-de-reception", element: <InboxPage /> },
    { path: "finances/documents", element: <DocumentsPage /> },
    { path: "finances/contrats", element: <ContractsPage /> },
    { path: "immeubles/copropriete", element: <CondoPage /> },
    { path: "immeubles/compteurs", element: <MetersPage /> },
    { path: "immeubles/assemblees-generales", element: <MeetingsPage /> },
    { path: "immeubles/communications", element: <CommunicationsPage /> },
  ],
  nav: [
    { to: "finances/recettes-et-depenses", label: "Recettes et dépenses", section: "Finances", perm: "read", order: 10, hideWhenRestricted: true },
    { to: "finances/tresorerie", label: "Trésorerie et rendement", section: "Finances", perm: "read", order: 11, hideWhenRestricted: true },
    { to: "finances/budget", label: "Budget", section: "Finances", perm: "read", order: 12, hideWhenRestricted: true },
    { to: "finances/export-comptable", label: "Export comptable", section: "Finances", perm: "read", order: 13, hideWhenRestricted: true },
    { to: "finances/boite-de-reception", label: "Boîte de réception", section: "Finances", perm: "read", order: 14, hideWhenRestricted: true },
    { to: "finances/documents", label: "Documents", section: "Finances", perm: "read", order: 15 },
    { to: "finances/contrats", label: "Contrats fournisseurs", section: "Finances", perm: "read", order: 16, hideWhenRestricted: true },
    { to: "immeubles/copropriete", label: "Copropriété (syndic)", section: "Immeubles", perm: "read", order: 20, hideWhenRestricted: true },
    { to: "immeubles/compteurs", label: "Compteurs", section: "Immeubles", perm: "read", order: 21 },
    { to: "immeubles/assemblees-generales", label: "Assemblées générales", section: "Immeubles", perm: "read", order: 22, hideWhenRestricted: true },
    { to: "immeubles/communications", label: "Communications", section: "Immeubles", perm: "read", order: 23, hideWhenRestricted: true },
  ],
  publicRoutes: [{ path: "/partage/:token", element: <PublicSharePage /> }],
  Dashboard: FinanceDashboard,
  propertyTabs: [
    { id: "finances", label: "Finances", order: 60, Component: PropertyFinanceTab },
    { id: "compteurs", label: "Compteurs", order: 61, Component: PropertyMetersTab },
  ],
  leaseTabs: [{ id: "documents-partages", label: "Documents partagés", order: 60, Component: LeaseSharesTab }],
  tenantSections: [{ id: "documents-partages", label: "Documents partagés", order: 60, Component: TenantSharedSection }],
};
